module.exports = __webpack_public_path__ + "static/media/inara_subtitle.fc402d73.svg";